export enum UIDataType {
  START_LOADING = "[UI] START_LOADING",
  STOP_LOADING = "[UI] STOP_LOADING",
  START_OPEN_ACCOUNTS_LOOKUP = "[UI] START OPEN ACCOUNTS LOOKUP",
  STOP_OPEN_ACCOUNTS_LOOKUP = "[UI] STOP OPEN ACCOUNTS LOOKUP",
  REFRESH_HOME_PAGE_DATA = "[UI] REFRESH HOME PAGE DATA",
}

export interface LoadingAction {
  readonly type: UIDataType;
  readonly payload: UIData;
}

export interface UIData {
  loading: boolean;
  openingAccountsLookup: boolean;
  refreshHomePageData: boolean;
}
